import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getGRNs
} from "../../api/grnApi";

const GRNList = () => {

  const [grns,setGrns] =
  useState([]);

  useEffect(()=>{

    loadGRNs();

  },[]);

  const loadGRNs =
  async()=>{

    const res =
    await getGRNs();

    setGrns(
      res.data.data
    );

  };

  return(

    <MainLayout>

      <div className="card">

        <div className="card-header">

          <h5>
            Goods Receipt Notes
          </h5>

        </div>

        <div className="card-body">

          <table className="table">

            <thead>

              <tr>

                <th>GRN No</th>
                <th>Supplier</th>
                <th>Invoice No</th>
                <th>Date</th>

              </tr>

            </thead>

            <tbody>

              {
                grns.map(
                  grn=>(
                    <tr
                      key={grn.id}
                    >

                      <td>
                        {grn.grn_no}
                      </td>

                      <td>
                        {grn.supplier_name}
                      </td>

                      <td>
                        {grn.invoice_no}
                      </td>

                      <td>
                        {grn.invoice_date}
                      </td>

                    </tr>
                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

    </MainLayout>

  );

};

export default GRNList;